import { Api } from '../axios-config';
import { Environment } from '../../../environment';
import { MePermissionsResponse } from './types/me-permissions.type';

export interface IAuth {
    accessToken: string;
}

const auth = async (email: string, password: string): Promise<IAuth> => {
  const { data }  = await Api({ disableResponseInterceptor: true }).post('/auth/login', { email, password });

  return data as IAuth;
};

const refreshAccessToken = async (accessToken: string): Promise<IAuth> => {
  const { data } = await Api()
    .put(`${Environment.URL_BASE}auth/refresh`,
      { refreshToken: accessToken },
      { headers:
          {
            'Authorization': `Bearer ${accessToken}`
          }
      });

  return {
    accessToken: data.accessToken
  }
}

const mePermissions = async (): Promise<MePermissionsResponse> => {
  const { data } = await Api().get('/me/permissions');

  return data as MePermissionsResponse;
};

export const AuthService = {
    auth,
    refreshAccessToken,
    mePermissions
};

